gsap.registerPlugin(ScrollTrigger, SplitText);

function initHighlightText() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let splitHeadingTargets = document.querySelectorAll('[data-highlight-text]');
    splitHeadingTargets.forEach((heading) => {
        if (reduceMotion) {
            // Skip the scroll-scrubbed word animation for reduced-motion users.
            heading.style.color = '#292929';
            return;
        }

        const scrollStart = heading.getAttribute('data-highlight-scroll-start') || 'top 90%';
        const scrollEnd = heading.getAttribute('data-highlight-scroll-end') || 'center 40%';
        const staggerValue = heading.getAttribute('data-highlight-stagger') || 0.05;

        new SplitText(heading, {
            type: 'words',
            autoSplit: true,
            onSplit(self) {
                let ctx = gsap.context(() => {
                    let tl = gsap.timeline({
                        scrollTrigger: {
                            scrub: 0.2,
                            ease: 'none',
                            trigger: heading,
                            start: scrollStart,
                            end: scrollEnd,
                        },
                    });
                    tl.to(self.words, {
                        color: '#292929',
                        stagger: staggerValue,
                        ease: 'none',
                    });
                });
                return ctx; // return our animations so GSAP can clean them up when onSplit fires
            },
        });
    });
}

// Initialize Highlight Text on Scroll
document.addEventListener('DOMContentLoaded', () => {
    initHighlightText();
});